// extracted by mini-css-extract-plugin
export var borderRadius = "_9i-4";
export var large = "_9i-3";
export var logoContainer = "_9i-0";
export var nameLogo = "_9i-2";
export var small = "_9i-1";